import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Col, Grid, Row } from 'react-flexbox-grid';
import Moment from 'moment';
import {Form} from 'react-bootstrap';
import {getMeetingTypes, getNote, getTeamMembers} from '../../../api';
import { projectStatusCodeMap } from '../../../components/ProjectStatusCodeMap';
import {Breadcrumb, Checkbox, DatePicker, Tooltip} from 'antd';
import Card from 'antd/es/card';
import { isViewOnlyOrExternalView } from '../../../utils/UserInfo';
import Errors from '../../../components/Errors';
import {CalendarOutlined, CloseOutlined} from '@ant-design/icons';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "axios";
import SpinnerNew from "../../../components/Spinner/SpinnerNew";
import {Label} from "reactstrap";
import {confirmAlert} from "react-confirm-alert";
import Alert from "../../../components/Alert";
import { oktaAuth } from 'oktaConfig';

const leftAlignLabel = {
    style: {textAlign: "left",
            fontWeight: "bold"}
}
const errorStyle = {
    color: 'red'
}

class MeetingNote extends Component {
    state = {
        note: {
            id: "",
            projectId: "",
            meetingLocation: "",
            meetingTypeId: 1,
            meetingType: "",
            meetingDate: "",
            notes: "",
        },
        error: null,
        meetingTypes: [],
        meetingGuideLines: [],
        meetingInvitees: [],
        selectInviteeList: [],
        meetingNoteAttachments: [],
        fileAttachments: [],
        spinnerOn: false,
        projectTeam: [],
        filteredProjectTeam: [],
        selectedProjectTeam: [],
        nonTeamMembers: '',
        filesizeOk: true,
    }

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMeetingDateChange = this.handleMeetingDateChange.bind(this);
        this.handleMeetingNotesBack = this.handleMeetingNotesBack.bind(this);
        this.handleSaveAndExit = this.handleSaveAndExit.bind(this);
        this.closeErrorBox = this.closeErrorBox.bind(this);
        this.onCheckInvitee = this.onCheckInvitee.bind(this);
        this.onSelectDeSelectInvitee = this.onSelectDeSelectInvitee.bind(this);
        this.onRemoveInvitees = this.onRemoveInvitees.bind(this);
        this.deleteSelectedFile = this.deleteSelectedFile.bind(this);
        this.handleSelectedFile = this.handleSelectedFile.bind(this);
        //this.handleFile = this.handleFile.bind(this);
        this.onInviteesAdd = this.onInviteesAdd.bind(this);
        this.onTeamMemberSelect = this.onTeamMemberSelect.bind(this);
        this.onNonMembersEdit = this.onNonMembersEdit.bind(this);
    }

    async componentDidMount() {
        this.setState({'spinnerOn': true});
        const params = this.props.match.params;
        let typeId = 1; // default to Kick-Off
        const meetingTypes = await getMeetingTypes();
        const team = await getTeamMembers(params.projectId);
        this.setState({'projectTeam': team});
        if (params.id === "new") {
            const note = {
                id: "",
                projectId: params.projectId,
                meetingLocation: "",
                meetingTypeId: typeId,
                meetingType: "",
                meetingDate: Moment().format('MMMM DD, YYYY'),
                invited: "",
                participated: "",
                notes: "",
                meetingInvitees: [],
                meetingNoteAttachments: []
            }
            this.setState({note, meetingTypes});
            this.setState({'filteredProjectTeam': team});
        } else {
            const note = await getNote(params.projectId, params.id);
            typeId = note.meetingTypeId;
            this.setState({note, meetingTypes});
            let filteredTeam = team.filter(obj => !note.meetingInvitees.map(p=>p.userId).includes(obj.userId));
            this.setState({'filteredProjectTeam': filteredTeam});
        }
        this.setState({'meetingGuideLines': meetingTypes.find(t=>t.meetingTypeId===typeId) !== null ?
                meetingTypes.find(t=>t.meetingTypeId===typeId).guideLines : []});
        //console.log('this.state.note.meetingInvitees', this.state.note.meetingInvitees);
        this.setState({'meetingInvitees': this.state.note!==null && this.state.note.meetingInvitees!==null ? this.state.note.meetingInvitees : []});
        this.setState({'meetingNoteAttachments': this.state.note!==null && this.state.note.meetingNoteAttachments!==null ? this.state.note.meetingNoteAttachments : []});
        this.setState({'spinnerOn': false});
    }

    handleInputChange(e) {
        const {note, meetingTypes} = this.state;
        const currentNote = note;
        const {value, name} = e.target;
        currentNote[name] = value;

        let type = meetingTypes.find(t=>t.meetingTypeId===parseInt(currentNote.meetingTypeId));
        this.setState({'meetingGuideLines': type !== null ? type.guideLines : []});
        currentNote['meetingType'] = type.meetingType;
        this.setState({note: currentNote});
    }

    handleMeetingDateChange(date){
        let myDate = null;
        if (date) {
            myDate = date.format('MMMM DD, YYYY');
        }
        const {note} = this.state;
        const currentNote = note;
        currentNote["meetingDate"] = myDate;

        this.setState({note: currentNote});
    }

    onCheckInvitee(e, record)
    {
        const newState = this.state.meetingInvitees.map(obj => {
            if (obj.userName === record.userName) {
                return {...obj, participated: (e.target.checked === true) ? 'Y' : 'N'};
            }
            return obj;
        });

        this.setState({'meetingInvitees': newState});
    }

    onSelectDeSelectInvitee(row, isSelect, rowIndex, e)
    {
        const {viewOnly} = this.props;
        let canEdit = !viewOnly && this.props.project.projectStatus !== projectStatusCodeMap["CLOSED"] && !isViewOnlyOrExternalView();
        if(!canEdit || e.target.type === 'checkbox')
            return false;
        if(isSelect == true)
        {
            const newState = [ ...this.state.selectInviteeList, row.userName ];
            this.setState({'selectInviteeList': newState});
        }
        else
        {
            const newState = this.state.selectInviteeList.filter(obj => obj !== row.userName);
            this.setState({'selectInviteeList': newState});
        }
    }

    onRemoveInvitees()
    {
        const newState = this.state.meetingInvitees.filter(obj => !this.state.selectInviteeList.includes(obj.userName));
        //console.log('meetingInvitees',newState);
        this.setState({'meetingInvitees': newState});
        this.setState({'selectInviteeList': []});

        // reset filteredProjectTeam
        let filteredTeam = this.state.projectTeam.filter(obj => !newState.map(p=>p.userId).includes(obj.userId));
        this.setState({'filteredProjectTeam': filteredTeam});
    }

    onTeamMemberSelect()
    {
        let list = [];
        let teamList = document.getElementById("team-member-list");
        for(let i=0; i<teamList.options.length;++i)
        {
            if(teamList.options[i].selected)
            {
                list.push(teamList.options[i].value);
            }
        }
        this.setState({'selectedProjectTeam': list});
    }

    onNonMembersEdit(e)
    {
        this.setState({'nonTeamMembers': e.target.value});
    }

    onInviteesAdd()
    {
        let insertList = this.state.projectTeam.filter(t=>this.state.selectedProjectTeam.includes(t.userId)).map(obj => {
            return ({'id':{'meetingId': null, 'userName': obj.firstName+' '+obj.lastName},
                'userName': obj.firstName+' '+obj.lastName, 'userId': obj.userId, 'participated': 'N'});
        });
        //console.log('insertList', insertList);
        let newList = [...insertList, ...this.state.meetingInvitees];
        let filteredTeam = this.state.projectTeam.filter(obj => !newList.map(p=>p.userId).includes(obj.userId));
        this.setState({'filteredProjectTeam': filteredTeam});

        // non team members
        let list = [];
        if(this.state.nonTeamMembers!=='')
        {
            list = this.state.nonTeamMembers.split(',').filter(t=>t!==null && t.trim()!=='').map(obj => {
                return ({
                    'id': {'meetingId': null, 'userName': obj.trim()},
                    'userName': obj.trim(), 'participated': 'N'
                });
            });
        }
        if(newList.length > 0)
        {
            list = list.filter(obj => !newList.map(p=>p.userName.toLocaleUpperCase()).includes(obj.userName.toLocaleUpperCase()));
        }

        const newState = [...list, ...insertList, ...this.state.meetingInvitees];
        this.setState({'meetingInvitees': newState});

        this.setState({'selectedProjectTeam': []});
        this.setState({'nonTeamMembers': ''});
    }

    deleteSelectedFile(fileName)
    {
        let pos = -1;
        if(fileName && fileName!=='')
        {
            pos = this.state.meetingNoteAttachments.findIndex(a=>a.fileName===fileName);
        }
        if(pos < 0) return;
        let attachments = this.state.meetingNoteAttachments;
        attachments.splice(pos,1);
        this.setState({'meetingNoteAttachments': attachments});
    }

    async handleSelectedFile(event) {
        let fileAttachments = event.target.files;
        await this.setState({
            'fileAttachments': fileAttachments
        });
        let filesizeOk = true;
        for (let i = 0; i < fileAttachments.length; i++) {
            if (fileAttachments[i].size > 100e6) {
                filesizeOk = false;
            }
        }
        this.setState({filesizeOk});
    }

    async handleFile(file, event) {
        const fileData = file.fileData;
        let tempArr = this.base64ToArrayBuffer(fileData);
        event.preventDefault();
        this.downloadToClient(fileData, tempArr, file);
    }

    base64ToArrayBuffer(base64) {
        let binaryString = window.atob(base64);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    downloadToClient(fileData, byte, file) {
        let blob = new Blob([byte], {type: "application/octet-stream"});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = file.fileName;
        link.click();

    }

    render() {
        const {project, status, viewOnly} = this.props;
        const {note, meetingTypes, meetingGuideLines, meetingInvitees, meetingNoteAttachments, spinnerOn, filteredProjectTeam,
            selectedProjectTeam, nonTeamMembers, filesizeOk} = this.state;
        let canEdit = !viewOnly && this.props.project.projectStatus !== projectStatusCodeMap["CLOSED"] && !isViewOnlyOrExternalView();
        const params = this.props.match.params;
        const infoText = <div>Multiple names can be added as a comma separated list.<br/>Example: Name1, Name2, Name3</div>;
        const columns = [
            {
                dataField: 'userName',
                text: 'Invited',
                style: { verticalAlign: 'middle'}
            },{
                dataField: 'participated',
                text: 'Participated',
                style: { textAlign: 'center', verticalAlign: 'middle' },
                headerStyle: (colum, colIndex) => {
                    return { width: '10%', textAlign: 'center' };
                },
                formatter: (text, record) => {
                return <Checkbox style={{width:10,height:10}} checked={record.participated==='Y'} disabled={!canEdit}
                                  onClick={(e) => this.onCheckInvitee(e, record)}/>;
                }

            }]

        return (
            <div id='meetingNotes'>
                <Errors error={this.state.error}
                        onCloseBox={this.closeErrorBox} />
                <SpinnerNew display={spinnerOn}/>
                <Row>
                    <Col md={4} xs={12}>
                        <Breadcrumb>
                            <Breadcrumb.Item><Link
                                to={`/${status}/${project.id}/notes`}
                                style={{fontsize: "30px"}}
                            >
                                Meeting Notes
                            </Link></Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {params.id==='new' ? 'New' : (canEdit===true ? 'Edit' : 'View')}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                { meetingGuideLines.length > 0 &&
                    <Row>
                        <Col md={12} xs={12}>
                            <Card>
                                <b><u>{note.meetingType} Guidelines</u></b>
                                <ol>
                                    {
                                        meetingGuideLines.map((g) => (
                                            <li>{g.guidelineText}</li>
                                        ))
                                    }
                                </ol>
                            </Card>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col md={4} xs={12}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Type</Form.Label>
                            <Form.Control as="select" value={note.meetingTypeId} name="meetingTypeId" onChange={this.handleInputChange}
                                          disabled={!canEdit}>
                                {meetingTypes.map((meetingType) => (
                                    <option
                                        id="meetingType"
                                        key={meetingType.meetingTypeId}
                                        value={meetingType.meetingTypeId}
                                    >   {meetingType.meetingType}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Meeting Date</Form.Label>
                            <DatePicker
                                id="meetingDateId"
                                onChange={this.handleMeetingDateChange}
                                value={note.meetingDate ? Moment(note.meetingDate) : note.meetingDate}
                                format={'MMMM DD, YYYY'}
                                suffixIcon={<CalendarOutlined />}
                                name={"meetingDate"}
                                disabled={!canEdit}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Meeting Location</Form.Label>
                            <Form.Control as="input" value={note.meetingLocation} name="meetingLocation" onChange={this.handleInputChange}
                                          maxLength={100}
                                          disabled={!canEdit}/>
                        </Form.Group>
                    </Col>
                </Row>
                <br/>
                <br/>
                <Row start='md' middle='md'>
                    <Col md={3}>
                        <Row>
                            <Col lg={10} md={10} xs={10}>
                                <Label><strong>Select Team Members</strong></Label>
                            </Col>
                        </Row>
                        <Row  style={{marginLeft:'5px'}}>
                            <Form.Control as="select" size={10} id="team-member-list" multiple={true} style={{width:300}}
                                          onChange={()=>this.onTeamMemberSelect()} disabled={!canEdit}>
                                {filteredProjectTeam && filteredProjectTeam.map((t) => (
                                    <option
                                        key={t.userId}
                                        value={t.userId}
                                    >   {t.firstName + ' ' + t.lastName}
                                    </option>
                                ))}
                            </Form.Control>
                        </Row>
                        <Row middle='md'>
                            <Col lg={10} md={10} xs={10}>
                            <Label><strong>Add Non Team Members</strong></Label>
                            </Col>
                            <Col>
                            <Tooltip title={infoText}>
                                <i className='fa fa-info-circle fa-1x' />
                            </Tooltip></Col>
                        </Row>
                        <Row  style={{marginLeft:'5px'}}>
                            <Form.Control as="textarea" style={{width:300}} rows="2" disabled={!canEdit}
                                          maxLength={50} value={nonTeamMembers} onChange={(e)=>this.onNonMembersEdit(e)}/>
                        </Row>
                    </Col>
                    <Col md={1}>
                        <button type="button" disabled={!canEdit || (selectedProjectTeam.length===0 && nonTeamMembers==='')} onClick={()=>this.onInviteesAdd()}>Add</button>
                    </Col>
                    <Col md={1}> </Col>
                    <Col md={5}>
                        <BootstrapTable keyField='userName'
                                        data={meetingInvitees && meetingInvitees.length>0 ? meetingInvitees : []}
                                        columns={columns}
                                        striped
                                        hover
                                        condensed
                                        selectRow={{
                                            mode: "checkbox",
                                            hideSelectColumn: true,
                                            clickToSelect: true,
                                            clickToEdit: true,
                                            bgColor: "#99ccff",
                                            onSelect: this.onSelectDeSelectInvitee
                                        }}
                                        pagination={paginationFactory({ sizePerPage: 8, hideSizePerPage: true })}
                        />
                    </Col>
                    <Col md={2}>
                        <button style={{marginRight:'50px'}} type="button" disabled={!canEdit || this.state.selectInviteeList.length===0} onClick={this.onRemoveInvitees}>Remove</button>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={12}>
                        <Form.Group>
                            <Form.Label {...leftAlignLabel}>Notes</Form.Label>
                            <Form.Control as="textarea" value={note.notes} name="notes" onChange={this.handleInputChange} rows="5"
                                          maxLength={4000}
                                          disabled={!canEdit}/>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <div style={{ marginTop: '24px' }}>
                    <Col md={12}>
                        <div id="file-class">
                            {canEdit === true &&
                            < input
                                type="file"
                                className="file-input"
                                id="uploadJ"
                                name="upload"
                                accept=".mp4, .mov, .pdf, .xlsx, .csv, .png, .jpg, .img, .docx, .pptx"
                                onChange={this.handleSelectedFile}
                                disabled={!canEdit}
                                multiple>
                            </input>
                            }

                            {meetingNoteAttachments ? meetingNoteAttachments.map(file => {
                                return (
                                    <div id={file.fileName}>
                                        <a href={file.fileName} download
                                           id={'download-file-'+file.fileName}
                                           onClick={this.handleFile.bind(this, file)}
                                        >
                                            {file.fileName}
                                        </a>
                                        {canEdit === true &&
                                        <span className="input-group-clear bg-light border-0"
                                            onClick={() => this.deleteSelectedFile(file.fileName)}>
                                                <CloseOutlined/>
                                        </span>
                                        }
                                    </div>
                                );
                            }) : ""
                            }
                            {!filesizeOk ?
                                <div className="error-file" style={errorStyle}>*You cannot add an attachment with the size of more than 100 MB</div> : ""}
                            </div>
                            </Col>
                    </div>
                </Row>

                <Row>
                    <Col md={12} style={{ padding: 15 }}>
                        {canEdit===true &&
                        <button type="button" className="btn btn-primary"
                                disabled={filesizeOk===false}
                                onClick={this.handleSaveAndExit}>Save
                        </button>
                        }
                        <button type="button" className="btn btn-primary" onClick={this.handleMeetingNotesBack}>{canEdit ? 'Cancel' : 'Close'}
                        </button>
                    </Col>
                </Row>
            </div>
        );
    }

    async handleSaveAndExit() {
        const { note, meetingInvitees, meetingNoteAttachments, fileAttachments} = this.state;
        if(meetingInvitees.length===0)
        {
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <Alert msg={'At least one Team Member or Non-Team Member must be Invited to the Meeting in order to Save the Meeting Note.'} onClose={onClose}/>
                    );
                }
            });
            return;
        }
        this.setState({'spinnerOn': true});
        note.meetingInvitees = meetingInvitees;
        note.meetingNoteAttachments = meetingNoteAttachments;
        const {project} = this.props;
        const projectId = project.id;
        let response = null;

        let formData = new FormData();
        formData.append( 'meetingNote', new Blob ([JSON.stringify({'projectId': projectId, 'meetingNote':note})], {
            type: "application/json"
        }));

        const files = Object.entries(fileAttachments);
        for (let i = 0; i < files.length; i++) {
            formData.append('attachFiles', files[i][1])
        }
const token = await oktaAuth.getAccessToken();
        await axios({
            method: 'post',
            url: `/api/meetingnotes/createupdate`,
            data: formData,
                   headers: { 
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'multipart/form-data'
  }
        })
            .catch(function (response) {
                console.log(response);
            });

        this.setState({'spinnerOn': false});
        //let response = await updateNotes(note);
        if(response && response.errorMessages && response.errorMessages.length > 0){
            this.handleErrors(response.errorMessages[0]);
        } else {
            this.props.handleRefreshCall();
            //this.props.history.push(`/${status}/${project.id}/notes`);
        }
    }

    handleErrors(error){
        this.setState({error});
        window.scrollTo(0,0);
    }

    closeErrorBox(){
        const error = null;
        this.setState({error});
    }

    handleMeetingNotesBack(){
        this.props.handleRefreshCall();
        //this.props.history.push(`/${this.props.status}/${this.props.project.id}/notes`);
    }

}
export default withRouter(MeetingNote);
